import type { DriveStep } from 'driver.js';

export const posHistoryTour: DriveStep[] = [
  {
    element: '[data-tour="history-stats"]',
    popover: {
      title: 'Stats Overview',
      description:
        "At-a-glance summary of today's orders — total count, revenue, pending payments, cancelled orders, pending items, and served items. Click on orders below to drill into details.",
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '[data-tour="history-filters"]',
    popover: {
      title: 'Search & Filter',
      description:
        'Search by order number or guest name. Filter by order type (Dine In, Takeout, Delivery) or by the staff member who created the order.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '[data-tour="history-table"]',
    popover: {
      title: 'Order History Table',
      description:
        'Every order is listed here with its number, type, payment status, table/guest, total amount, and current status. Checkboxes on the left let you select orders for batch actions.',
      side: 'top',
      align: 'start',
    },
  },
  {
    element: '[data-tour="history-view-btn"]',
    popover: {
      title: 'View Order Details',
      description:
        'Click the eye icon to open the order detail modal. It shows every item in the order, payment info, status timeline, and per-item lifecycle timing (prep, serve, total).',
      side: 'left',
      align: 'start',
    },
  },
  {
    element: '[data-tour="history-actions"]',
    popover: {
      title: 'Batch Actions',
      description:
        'Select two or more orders using the checkboxes, then use Merge Bills to combine them, or Clear to deselect all. Pay and Cancel are available per individual order.',
      side: 'bottom',
      align: 'center',
    },
  },
];
